import { render, staticRenderFns } from "./IApple.vue?vue&type=template&id=ce2bbada&scoped=true&"
import script from "./IApple.vue?vue&type=script&lang=js&"
export * from "./IApple.vue?vue&type=script&lang=js&"
import style0 from "./IApple.vue?vue&type=style&index=0&id=ce2bbada&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce2bbada",
  null
  
)

export default component.exports